import React, { useState, useEffect } from 'react';
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
  Area,
  AreaChart
} from 'recharts';

// Removemos date-fns por ahora y usaremos Date nativo

const normalize = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.$values)) return data.$values;
  return [];
};

const DashboardPausa= () => {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  
  const [fechaSeleccionada, setFechaSeleccionada] = useState(() => new Date());
  const [sucursales, setSucursales] = useState([]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);  


  const [resumen, setResumen] = useState({});
  const [motivos, setMotivos] = useState([]);
  const [porUsuario, setPorUsuario] = useState([]);
  const [pausasActivas, setPausasActivas] = useState([]);
  const [pausasPorHora, setPausasPorHora] = useState([]);
  const [pausasFinalizadas, setPausasFinalizadas] = useState([]);
  const [tipoFiltro, setTipoFiltro] = useState("activasTodas");
  const [pausasActivasTodas, setPausasActivasTodas] = useState([]);
  

    const fetchSucursales = async () => {
      try {
        const response = await fetch(`${server}/tickets/tbl_motivo_pausa/dashboard/sucursales`, {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': key,
          }
        });
        if (response.ok) {
          const data = await response.json();
          setSucursales(data.$values || data);
        }
      } catch (error) {
        console.error('Error al obtener sucursales:', error);
      }
    };

    // 🔥 Fetch principal
 const fetchDatosDashboard = async (fechaParam = fechaSeleccionada, sucursalParam = sucursalSeleccionada) => {

  try {
    const fecha = fechaParam.toISOString().split("T")[0];

    let resumenUrl = `${server}/tickets/tbl_motivo_pausa/resumen?fecha=${fecha}`;
    if (sucursalParam !== null) {
      resumenUrl += `&idSucursal=${sucursalParam}`;
    }

    let activasHoyUrl = `${server}/tickets/tbl_motivo_pausa/activas?fecha=${fecha}`;
    if (sucursalParam !== null) {
      activasHoyUrl += `&idSucursal=${sucursalParam}`;
    }

    let activasTodasUrl = `${server}/tickets/tbl_motivo_pausa/activas-todas`;
    if (sucursalParam !== null) activasTodasUrl += `?idSucursal=${sucursalParam}`;

    let finalizadasUrl = `${server}/tickets/tbl_motivo_pausa/finalizadas?fecha=${fecha}`;
    if (sucursalParam !== null) {
      finalizadasUrl += `&idSucursal=${sucursalParam}`;
    }

    const [resumenRes, motivosRes, usuariosRes, activasHoyRes, activasTodasRes, finalizadasRes] = await Promise.all([
      fetch(resumenUrl),
      fetch(`${server}/tickets/tbl_motivo_pausa/motivos?fecha=${fecha}`),
      fetch(`${server}/tickets/tbl_motivo_pausa/por-usuario?fecha=${fecha}`),
      fetch(activasHoyUrl),
      fetch(activasTodasUrl),
      fetch(finalizadasUrl)
    ]);

    const resumenData = await resumenRes.json();
    const motivosData = await motivosRes.json();
    const usuariosData = await usuariosRes.json();
    const activasHoyData = await activasHoyRes.json();
    const activasTodasData = await activasTodasRes.json();
    const finalizadasData = await finalizadasRes.json();


    setResumen(resumenData);
    normalize(usuariosData)
    setPorUsuario(normalize(usuariosData));
    setPausasActivas(normalize(activasHoyData));
    setPausasActivasTodas(normalize(activasTodasData));
    setPausasFinalizadas(normalize(finalizadasData));
    setMotivos(normalize(motivosData).map(m => ({
      name: m.motivoPausa,
      value: m.cantidad
    })));

  } catch (error) {
    console.error("Error cargando dashboard:", error);
  }
};

    useEffect(() => {
      fetchSucursales();
      fetchDatosDashboard(fechaSeleccionada, sucursalSeleccionada);

      const interval = setInterval(() => {
        fetchDatosDashboard(fechaSeleccionada, sucursalSeleccionada);
      }, 10000);
    
      return () => clearInterval(interval);
    }, [fechaSeleccionada, sucursalSeleccionada]);

    const formatearTiempo = (minutos) => {
      if (minutos < 60) {
        return `${parseFloat(minutos.toFixed(2))}m`;
      }
      const horas = Math.floor(minutos / 60);
      const minutosRestantes = parseFloat((minutos % 60).toFixed(2));
      return `${horas}h ${minutosRestantes}m`;
    };

    const handleFechaChange = (event) => {
      const nuevaFecha = new Date(event.target.value + 'T00:00:00');
      setFechaSeleccionada(nuevaFecha);
      fetchDatosDashboard(nuevaFecha, sucursalSeleccionada);
    };
      // Función para manejar cambio de sucursal
    const handleSucursalChange = (event) => {
      const nuevaSucursal = event.target.value;

      const sucursalInt = nuevaSucursal ? parseInt(nuevaSucursal) : null;

      setSucursalSeleccionada(sucursalInt);
      fetchDatosDashboard(fechaSeleccionada, sucursalInt);
    };

      // Función para formatear fecha para input type="date"
  const formatearFechaParaInput = (fecha) => {
    return fecha.toISOString().split('T')[0];
  };

  const getDataTabla = () => {
    switch (tipoFiltro) {
      case "activasHoy":
        return pausasActivas;

      case "finalizadas":
        return pausasFinalizadas;

      case "activasTodas":
      default: return pausasActivasTodas;
    }
  }

  //Datos para grafico Activas vs Finalizadas
  const total = (resumen.pausasActivasHoy || 0) + (resumen.pausasFinalizadasHoy || 0); 

  const dataRatio = [
    {
      name: "Activas",
      value: resumen.pausasActivasHoy || 0
    },
    {
      name: "Finalizadas",
      value: resumen.pausasFinalizadasHoy || 0
    }
  ];

    return (
      <div className="right_col" role="main">
        <div className="">
          <div className="page-title">
            <div className="title_left">
              <h3>Dashboard - Pausas</h3>
            </div>

            <div className="title_right">
          <div className="col-md-7 col-sm-7 form-group pull-right top_search">

            {/* Fecha */}
            <div className="input-group">
              <span className="input-group-addon">
                <i className="fa fa-calendar"></i>
              </span>
              <input
                type="date"
                className="form-control"
                value={formatearFechaParaInput(fechaSeleccionada)}
                onChange={handleFechaChange}
                style={{ borderRadius: 0 }}
              />
              <span className="input-group-btn">
                <button 
                  className="btn btn-default"
                  type="button"
                  onClick={() => fetchDatosDashboard()}
                  title="Actualizar datos"
                >
                  <i className="fa fa-refresh"></i>
                </button>

                <button 
                  className="btn btn-primary"
                  onClick={() => {
                    const hoy = new Date();
                    setFechaSeleccionada(hoy);
                    fetchDatosDashboard();
                  }}
                >
                  Hoy
                </button>
              </span>
            </div>

            {/* Sucursal */}
            <div className="input-group" style={{ marginTop: '6px' }}>
              <span className="input-group-addon">
                <i className="fa fa-building"></i>
              </span>
              <select
                className="form-control"
                value={sucursalSeleccionada ?? ""}
                onChange={handleSucursalChange}
              >
                <option value="">Todas las sucursales</option>
                {sucursales.map(s => (
                  <option key={s.id} value={s.id}>
                    {s.nombre}
                  </option>
                ))}
              </select>
            </div>

          </div>
        </div>
      </div>

      <div className="clearfix"></div>

      {/* 🔹 KPIs */}
      <div className="row">

        {/* <div className="col-md-3 col-sm-6 col-xs-12">
          <div 
            className="x_panel tile"
            onClick={() => setTipoFiltro("activasTodas")}
            style={{
              cursor: "pointer",
              border: tipoFiltro === "activasTodas" ? "2px solid #d9534f" : ""
            }}
            >

            <div className="x_title">
              <h2>Total de Pausas Activas</h2>
            </div>
            <div className="x_content text-center">
              <h1 style={{ fontSize: 48, color: "#d9534f" }}>
                {resumen.pausasActivasTodas || 0}
              </h1>
            </div>
          </div>
        </div> */}

        <div className="col-md-3 col-sm-6 col-xs-12">
          <div 
            className="x_panel tile"
            onClick={() => setTipoFiltro("activasHoy")}
            style={{
              cursor: "pointer",
              border: tipoFiltro === "activasHoy" ? "2px solid #0275d8" : ""
            }}
            >
            <div className="x_title">
              <h2>Pausas Activas Hoy</h2>
            </div>
            <div className="x_content text-center">
              <h1 style={{ fontSize: 48, color: "#0275d8" }}>
                {resumen.pausasActivasHoy || 0}
              </h1>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-sm-6 col-xs-12">
          <div
            className="x_panel tile"
            onClick={() => setTipoFiltro("finalizadas")}
            style={{
              cursor: "pointer",
              border: tipoFiltro === "finalizadas" ? "2px solid #5bc0de" : ""
            }}
            >
            <div className="x_title">
              <h2>Finalizadas (Filtro)</h2>
            </div>
            <div className="x_content text-center">
              <h1 style={{ fontSize: 48, color: "#5bc0de" }}>
                {resumen.pausasFinalizadasHoy || 0}
              </h1>
            </div>
          </div>
        </div>

        {/* <div className="col-md-3 col-sm-6 col-xs-12">
          <div className="x_panel tile">
            <div className="x_title">
              <h2>Promedio</h2>
            </div>
            <div className="x_content text-center">
              <h1 style={{ fontSize: 32, color: "#f0ad4e" }}>
                {formatearTiempo(resumen.promedioMinutos || 0)}
              </h1>
            </div>
          </div>
        </div> */}

        {/* <div className="col-md-3 col-sm-6 col-xs-12">
          <div className="x_panel tile">
            <div className="x_title">
              <h2>Tiempo Total</h2>
            </div>
            <div className="x_content text-center">
              <h1 style={{ fontSize: 32, color: "#5bc0de" }}>
                {formatearTiempo(resumen.totalMinutosHoy || 0)}
              </h1>
            </div>
          </div>
        </div> */}

      </div>

      {/* 🔹 GRÁFICAS */}
      <div className="row">

        {/* Motivos */}
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x-panel">
            <div className="x_title">
              <h2> Pausas por Motivo </h2>
            </div>
            
            <div className="x_content">
              <ResponsiveContainer width="100%" height={400}>
                  <PieChart>
                    <Pie
                      data={motivos}
                      dataKey="value"
                      nameKey="name"
                      innerRadius={60}
                      outerRadius={110}
                      paddingAngle={3}
                      label={({ name, percent}) => 
                        `${name} (${(percent * 100).toFixed(0)}%`
                      }
                    >
                      {motivos.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={[
                            "#d9534f", // rojo
                            "#0275d8", // azul
                            "#5bc0de", // celeste
                            "#5cb85c", // verde
                            "#f0ad4e", // naranja
                            "#6f42c1", // morado
                            "#e84393"  // rosado
                          ][index % 7]}
                          />
                      ))}
                    </Pie>
                    < Tooltip formatter={(value, name) => [`${value} pausas`, name]} />
                    <Legend />
                  </PieChart>
              </ResponsiveContainer>
            </div>
        </div>
      </div>

      <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x-panel">
            <div className="x-title">
                <h2>Activas vs Finalizadas</h2>
            </div>
            <div className='x_content text-center'>
              <h4>Total: {total}</h4>

              <ResponsiveContainer width="100%" height={250}>
                <PieChart>
                  <Pie
                    data={dataRatio}
                    dataKey="value"
                    nameKey="name"
                    innerRadius={60}
                    outerRadius={90}
                    label={({ percent }) => `${(percent * 100).toFixed(0)}%`}
                  >
                    <Cell fill='#f0ad4e' />
                    <Cell fill='#5bc0de' />
                  </Pie>
                  <Tooltip formatter={(value) => `${value} pausas`} />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </div>
      </div>

        {/* Usuarios */}
        {/* <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>Pausas por Usuario</h2>
            </div>
            <div className="x_content">
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={porUsuario}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="nombre" angle={-30} textAnchor="end" height={70}/>
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="totalMinutos" fill="#d9534f" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div> */}

      </div>
      

      {/* 🔹 TABLA TIEMPO REAL */}
      <div className="row">
        <div className="col-md-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>
                {tipoFiltro === "activas" && "Pausas Activas"}
                {tipoFiltro === "activasHoy" && "Pausas Activas Hoy"}
                {tipoFiltro === "finalizadas" && "Pausas Finalizadas"}
              </h2>
            </div>

            <div className="x_content">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Colaborador</th>
                    <th>Motivo</th>
                    <th>Sucursal</th>
                    <th>Ubicación</th>
                    <th>Inicio</th>
                    <th>Fin</th>
                    {/* <th>Min</th> */}
                  </tr>
                </thead>
                <tbody>
                  {getDataTabla().map(p => (
                    <tr key={p.id_motivo_pausa}>
                      <td>{p.colaborador}</td>
                      <td>{p.motivo_pausa}</td>
                      <td>{p.sucursal}</td>
                      <td>{p.ubicacion}</td>
                      {/* <td>{p.hora_inicio}</td> */}
                      <td>{p.hora_inicio?.replace("T", " ")}</td>
                      <td>{p.hora_fin?.replace("T", " ")}</td>
                      {/* <td>{p.minutosEnPausa}</td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>

      </div>
      </div>
    );
};

export default DashboardPausa;